import { useState } from 'react'
import TextInput from '../TextInput/TextInput'
import RadioInput from '../RadioInput/RadioInput'
import TextInputArea from '../TextInputArea/TextInputArea'
import FormSuccessDialog from '../FormSuccessDialog/FormSuccessDialog'
import FormErrorDialog from '../FormErrorDialog/FormErrorDialog'
import { BASE_URL } from '../../constants'
import { getRecaptchaV3Token } from '../../utils/recaptcha'
import RecaptchaModal from '../Recaptcha/RecaptchaModal'

export const ContactForm = () => {
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [email, setEmail] = useState('')
  const [userType, setUserType] = useState('')
  const [message, setMessage] = useState('')

  const [disabledField, setDisabledField] = useState(false)
  const [showError, setshowError] = useState(false)
  const [showSuccess, setshowSuccess] = useState(false)
  const [showCheckboxFallback, setShowCheckboxFallback] = useState(false)
  const [pendingSubmitData, setPendingSubmitData] = useState(null)

  const toggleModal = () => {
    setshowError(false)
    setshowSuccess(false)
  }

  const submitForm = async e => {
    e.preventDefault()
    setDisabledField(true)
    let token
    try {
      token = await getRecaptchaV3Token('contact_form')
    } catch (err) {
      setshowError(true)
      setDisabledField(false)
      return
    }

    const payload = {
      first_name: firstName,
      last_name: lastName,
      email_address: email,
      who_are_you: userType,
      message: message,
      captcha_token: {
        token,
        version: 'v3',
        provider: 1,
      },
    }

    const doSubmit = async body => {
      return fetch(`${BASE_URL}/Marketing/ContactUs`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      })
    }

    let response
    try {
      response = await doSubmit(payload)
    } catch (err) {
      setshowError(true)
      setDisabledField(false)
      return
    }

    if (response.status === 400) {
  // If server asks for additional verification (400), ensure the generic
  // error dialog is not shown and present the v2 checkbox fallback.
  setshowError(false)
  setPendingSubmitData(payload)
      setShowCheckboxFallback(true)
      setDisabledField(false)
      return
    }

    if (response.status < 200 || response.status > 299) {
      setshowError(true)
      setDisabledField(false)
    } else {
      setshowSuccess(true)
    }
  }

  const handleCheckboxVerify = async token => {
    if (!pendingSubmitData) return
    setShowCheckboxFallback(false)
    setDisabledField(true)
    const res = await fetch(`${BASE_URL}/Marketing/ContactUs`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        ...pendingSubmitData,
        captcha_token: {
          token,
          version: 'v2',
          provider: 1,
        },
      }),
    })
    setPendingSubmitData(null)
    if (res.status >= 200 && res.status <= 299) {
      setshowSuccess(true)
    } else {
      setshowError(true)
    }
    setDisabledField(false)
  }

  return (
    <div className="max-w-screen-xl px-4 py-12 mx-auto mt-16 sm:px-6 lg:px-8 bg-lightblue">
      <div className="text-center">
        <h2 className="pb-4 text-3xl tracking-tight md:text-4xl">
          Health Insurance with a human touch.
        </h2>
        <h3 className="text-2xl font-bold uppercase text-blue">
          We’d love to hear from you. Reach out to learn more.
        </h3>
      </div>
      <div id="recaptcha-container-invisible" style={{ display: 'none' }}></div>
      <div className="relative">
  {showSuccess && (
          <FormSuccessDialog userType={userType} toggleModal={toggleModal} />
        )}

        {showError && (
          <FormErrorDialog
            click={e => {
              setshowError(false)
            }}
          />
        )}

        <form onSubmit={submitForm} className="grid grid-cols-1 md:grid-cols-3">
          <div className="col-span-1 md:col-span-2">
            <div className="grid grid-cols-1 md:grid-cols-2">
              <div className="md:col-span-1">
                <TextInput
                  required
                  labelClasses="bg-white-light"
                  type="text"
                  minLength={2}
                  maxLength={20}
                  disabled={disabledField}
                  value={firstName}
                  change={e => {
                    setFirstName(e.target.value)
                  }}
                >
                  First Name
                </TextInput>
              </div>
              <div className="md:col-span-1">
                <TextInput
                  required
                  labelClasses="bg-white-light"
                  type="text"
                  minLength={2}
                  maxLength={20}
                  disabled={disabledField}
                  value={lastName}
                  change={e => {
                    setLastName(e.target.value)
                  }}
                >
                  Last Name
                </TextInput>
              </div>
              <div className="md:col-span-2">
                <TextInput
                  required
                  labelClasses="bg-white-light"
                  type="email"
                  minLength={2}
                  maxLength={60}
                  disabled={disabledField}
                  value={email}
                  change={e => {
                    setEmail(e.target.value)
                  }}
                >
                  Email
                </TextInput>
              </div>
            </div>
          </div>
          <div className="col-span-1 md:col-span-1">
            <div
              className="py-3 my-4 border-white border-solid border-1 bg-white-light"
              role="group"
            >
              <h4 className="text-xl text-darkGray pl-4 font-[sans-serif]">
                Who are you? *
              </h4>
              <RadioInput
                required
                name="userType"
                value="employer"
                selectedValue={userType}
                tabIndex="0"
                change={e => {
                  setUserType(e.target.value)
                }}
              >
                Employer
              </RadioInput>
              <RadioInput
                required
                name="userType"
                value="individual"
                selectedValue={userType}
                tabIndex="0"
                change={e => {
                  setUserType(e.target.value)
                }}
              >
                Individual
              </RadioInput>
              <RadioInput
                required
                name="userType"
                value="broker"
                selectedValue={userType}
                tabIndex="0"
                change={e => {
                  setUserType(e.target.value)
                }}
              >
                Broker
              </RadioInput>
            </div>
          </div>
          <div className="md:col-span-3">
            <TextInputArea
              required
              labelClasses="bg-white-light"
              type="text"
              minLength={20}
              maxLength={2000}
              value={message}
              change={e => {
                setMessage(e.target.value)
              }}
            >
              Message
            </TextInputArea>
          </div>
          <div className="mx-auto mt-8 md:col-span-3">
            <button
              type="submit"
              className="px-12 py-2 text-lg font-medium text-white bg-blue"
            >
              Send
            </button>
          </div>
        </form>
        {showCheckboxFallback && (
          <div style={{ position: 'fixed', inset: 0, zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div style={{ background: 'rgba(0,0,0,0.5)', position: 'absolute', inset: 0 }} />
            <div style={{ zIndex: 10000, background: '#fff', padding: 20, borderRadius: 8 }}>
              <p style={{ marginBottom: 10 }}>Please complete the verification to continue</p>
              <RecaptchaModal
                onVerify={token => handleCheckboxVerify(token)}
                onError={() => {
                    setShowCheckboxFallback(false)
                    setshowError(true)
                  }}
                onClose={() => setShowCheckboxFallback(false)}
              />
              <div style={{ marginTop: 8, textAlign: 'right' }}>
                <button type="button" className="px-4 py-2 text-sm" onClick={() => { setShowCheckboxFallback(false) }}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default ContactForm
